module.exports = __webpack_public_path__ + "img/frame (214).3afbbdf9.jpg";